import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_thbeyjag8q: FaireBrandEntity = {
  token: "b_thbeyjag8q",
  type: "brand",
  name: "Baby Bliss",
  avatarUrl:
    "https://cdn.faire.com/fastly/3591c657d6378ca6a233c111e44fe8a8cb2231a5a20ac4442f202a7ab6a3aa6d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/0f91d335c032207444f9adca9422c7b7d014ee9dc43af900b7954d75f4e9ae32.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3591c657d6378ca6a233c111e44fe8a8cb2231a5a20ac4442f202a7ab6a3aa6d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0f91d335c032207444f9adca9422c7b7d014ee9dc43af900b7954d75f4e9ae32.jpeg",
  location: "Halifax, NS, CAN",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 27,
  isInsider: false,
  description:
    "At Baby Bliss, we on a mission to create long-lasting, aesthetically pleasing baby products with functionally, practicality, and safety at top of mind. Our baby, toddler, and children essentials are designed in Canada and made from 100% premium food grade silicone. Free of BPA, PVC, Phthalates & Lead. Proudly owned by a mom of 2 babies who strives for the absolute best for all little ones — & settles for nothing less.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:31.211Z",
    importedBy: "entity-db-cli",
  },
};
